import { TInputTag } from "components/InputMultipleTag";

import { TGetBUUnassignedMemberFilter } from "./types";
import { TFinalSort } from "components/Table/types";
import { EAccount } from "types/index";

export const MEMBER_TYPE_TAG_OPTIONS: TInputTag[] = [
  { id: EAccount.CLIENT, name: "Client" },
  { id: EAccount.STAFF, name: "Staff" },
  { id: EAccount.CORPORATION, name: "Corporation" },
];

export const DEFAULT_BU_UNASSIGNED_MEMBER: TGetBUUnassignedMemberFilter = {
  idBu: "",
  memberType: undefined,
  keyword: undefined,
};

export const DEFAULT_SORT_UNASSIGNED_MEMBER: Record<string, TFinalSort> = {
  name: {
    fieldName: "name",
    key: "name",
    type: "none",
  },
  idMember: {
    fieldName: "id_member",
    key: "idMember",
    type: "none",
  },
  memberType: {
    fieldName: "account_type",
    key: "memberType",
    type: "none",
  },
};

export const SORT_MAP_UNASSIGNED_MEMBER = {
  name: "name",
  id_member: "idMember",
  member_type: "memberType",
};
